export default __webpack_public_path__ + "static/media/cart.d17104e1.svg";